<template>
  <twitterqueries-form :available-sources="availableSources"></twitterqueries-form>
</template>

<script>
export default {
  props: ['availableSources']
}
</script>
